import {
  BusinessTravelerResponse,
  FeaturesFlag
} from '../../models/business-traveler.interfaces';

export const BusinessTravelerFeatureFlagMocks: FeaturesFlag = {
  flags: {
    enrollment: true,
    overview: true
  },
  defaultURL: {
    enrollment: '/us/en/need-help/',
    overview: '/myskymiles/overview'
  }
};

export const BusinessTravelerFeatureFlagFalseMocks: FeaturesFlag = {
  flags: {
    enrollment: false,
    overview: false
  },
  defaultURL: {
    enrollment: '/us/en/need-help/',
    overview: '/myskymiles/overview'
  }
};

export const BusinessTravelerContentMocks: BusinessTravelerResponse = {
  data: {
    loyalty_program: {
      loyaltyMemberAccount: {
        loyaltyMemberEligibility: {
          deltaBusinessTraveler: true,
          dbtPrompt: false
        }
      }
    }
  }
};

export const BusinessTravelerContentFalseMocks: BusinessTravelerResponse = {
  data: {
    loyalty_program: {
      loyaltyMemberAccount: {
        loyaltyMemberEligibility: {
          deltaBusinessTraveler: false,
          dbtPrompt: false
        }
      }
    }
  }
};
